/// <reference path="~/js/global.js"/>
/// <reference path="~/js/lib/lodash.js"/>

(function() {
  "use strict";

  var ns;

  ns = window.nspace("ccc.viz.profile.config");

  ns.Config = {
    /**
     * Gets what the colSpan should be for various types of cells.
     */
    getCellWidth: function(cell, availableDataPrimitives, actualDataFormats) {
      var colSpan, primitiveIsSelected;

      colSpan = 0;

      // A non data cell.
      if (!cell.primitiveId) {
        _.each(availableDataPrimitives, function(value, key) {
          if (actualDataFormats[0] === "a") {
            colSpan += _.keys(value.dataFormats).length;
            return;
          }

          _.each(actualDataFormats, function(actualDataFormat) {
            if (+key === +actualDataFormat) {
              colSpan += _.keys(value.dataFormats).length;
            }
          });
        });
        return colSpan;
      }

      // All data formats are selected.
      if (actualDataFormats[0] === "a") {
        return 1;
      }

      primitiveIsSelected = _.any(actualDataFormats, function(dataFormat) {
        return +dataFormat === +cell.primitiveId;
      });

      // This cell's data format is selected.
      if (primitiveIsSelected) {
        return 1;
      }

      return null;
    },

    /**
     * Determines whether a given set of indicator tables should be shown given the available data types and what the user has selected.
     */
    shouldShowTable: function(availableDataPrimitives, actualDataPrimitives) {
      var i, primitive, availablePrimitiveKeys, primitiveInCollection;

      if (actualDataPrimitives[0] === "a") {
        return true;
      }

      availablePrimitiveKeys = _.keys(availableDataPrimitives);

      for (i = 0; i < actualDataPrimitives.length; i++) {
        primitive = +actualDataPrimitives[i];

        primitiveInCollection = _.any(availablePrimitiveKeys, function(key) {
          return +key === primitive;
        });

        if (primitiveInCollection) {
          return true;
        }
      }

      return false;
    },

    /**
     * If the table hasn't been fully rendered yet, no need to animate the showing of the notes and definitions, so
     * when off, use a duration of 0 to trigger an immediate hide - otherwise, animate the display change.
     */
    animationOptions: {
      off: { duration: 0 },
      on: { duration: 400 }
    },

    /**
     * A mapping of features to animations.
     */
    featureSelectors: {
      ".notes-definitions-sources": {
        id: 1,
        on: function($el, options) {
          $el.slideDown(options);
        },
        off: function($el, options) {
          $el.slideUp(options);
        }
      },
      ".change-table": {
        id: 2,
        on: function($el, options) {
          $el.fadeIn(options);
        },
        off: function($el, options) {
          $el.hide();
        }
      }
    },

    /**
     * A mapping of LargerValuesAre to images.
     * TODO: merge with mapping in SelectedRegionTableView?
     */
    changeImages: {
      arrowUrls: {
        up: {
          alt: "Higher",
          Worse: "/images/change/change-red-up.png",
          Better: "/images/change/change-green-up.png",
          Neutral: "/images/change/change-gray-up.png"
        },
        down: {
          alt: "Lower",
          Worse: "/images/change/change-green-down.png",
          Better: "/images/change/change-red-down.png",
          Neutral: "/images/change/change-gray-down.png"
        },
        noChange: {
          alt: "No Change",
          url: "/images/change/no-change.png"
        }
      }
    }
  };
})();
